import * as React from 'react';
import { useState, useEffect } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_timesheet_wizard/AddTimesheetForm.scss';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import Input from '../../components/Input';
import { listPossibleBenefitPeriods } from '../../redux/actions/table/company_benefits';

const AddCompanyBenefitsForm = (props) => {
  const [possible_periods, set_possible_periods] = useState([]);

  const _handleSubmit = (edit) => {
    props.change('edit', edit);

    setTimeout(() => props.submit(), 10);
  };

  const countries = _.map(props.localization.countries, (country) => {
    return {
      value: country.id,
      label: country.name,
    };
  });

  useEffect(() => {
    listPossibleBenefitPeriods().then(({ response }) => {
      set_possible_periods(response?.data);
    });
  }, []);

  return (
    <Form className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='name'
          component={Input}
          label={__('table.columns.company-benefits.name')}
          placeholder={__('add-company-benefits-form.add-name')}
        />
        <Field
          name='period'
          component={Select}
          label={__('table.columns.company-benefits.period')}
          options={_.map(possible_periods, (period) => ({
            value: period,
            label: period,
          }))}
          placeholder={__('add-company-benefits-form.select-period')}
          searchable={true}
        />

        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={props.actions.hideAddTimesheetWizard}
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              middleText={__('button.create')}
              spinning={props.submitting}
              onClick={() => _handleSubmit(false)}
            />
          </ButtonGroup>
        </div>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    values: getFormValues('add_company_benefits.company_benefits')(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      hideAddTimesheetWizard: () =>
        dispatch({
          type: 'table.company_benefits/SET_TABLE_PARAMS',
          params: {
            wizard_active: undefined,
          },
        }),
    },
  };
};

export default withRouter(
  reduxForm({
    form: 'add_company_benefits.company_benefits',
  })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(subscribe(Localization, 'localization')(AddCompanyBenefitsForm))
  )
);
